import { uniq, keys } from 'lodash';
import * as colourHelpers from './colours';
import * as componentHelper from './componentHelper';
import * as dispatcherTypeHelper from './dispatcherTypes';

export const ARTIFACTS_TEAM = 'Artifacts';
export const ACQUIRE_TEAM = 'Acquire';
export const CLOUD_TEAM = 'Cloud';
export const DATA_ANALYTICS_TEAM = 'Data Analytics';
export const ENGINE_TEAM = 'Engine';
export const EXAMINE_TEAM = 'Examine';
export const ONE_AGENT_TEAM = 'One Agent';
export const STS_TEAM = 'STS';
export const upVoteScore = 1;
export const downVoteScore = -1;
export const neutralVoteScore = 0;
export const FETCH_DAYS = 60;


export const DISPATCHERTYPE_VS_TEAMS =
{
  'ArtifactPerformance': [ARTIFACTS_TEAM],
  'ArtifactRegression': [ARTIFACTS_TEAM],
  'CaseMetrics': [ENGINE_TEAM],
  'DifftoolRegression': [ARTIFACTS_TEAM, ENGINE_TEAM, EXAMINE_TEAM, STS_TEAM],
  'UITests': [EXAMINE_TEAM],
  'ExportTests': [EXAMINE_TEAM],
  'RemoteAcquireRegression': [ONE_AGENT_TEAM],
  'CaseAmendingTests': [EXAMINE_TEAM],
  'AcquisitionTests': [ACQUIRE_TEAM],
  'CloudTests': [STS_TEAM],
  'UIInstallerTests': [STS_TEAM],
  'AnalyticsEngineTests': [ENGINE_TEAM, DATA_ANALYTICS_TEAM],
  'PerformanceTests': [EXAMINE_TEAM],
  'DeviceIntegrationTests': [ACQUIRE_TEAM],
  'CaseMergingTests': [EXAMINE_TEAM],
  'AxiomUITests': [ENGINE_TEAM]
};

export const upVoteScoreData = (isManual) =>
{
  const data = {
    score: upVoteScore,
    panelStyle: componentHelper.PANEL_STYLES.PRIMARY,
    pointOptions: {
      pointBackgroundColor: colourHelpers.colours.blue,
      pointRadius: 8
    },
    isManual: isManual
  };
  return data;
};

export const downVoteScoreData = (isManual) =>
{
  const data = {
    score: downVoteScore,
    panelStyle: componentHelper.PANEL_STYLES.DANGER,
    pointOptions: {
      pointBackgroundColor: colourHelpers.colours.red,
      pointRadius: 8
    },
    isManual: isManual
  };
  return data;
};

export const neutralVoteScoreData = (isManual) =>
{
  const data =
  {
    score: neutralVoteScore,
    panelStyle: componentHelper.PANEL_STYLES.WARNING,
    pointOptions: {
      pointBackgroundColor: colourHelpers.colours.yellow,
      pointRadius: 8
    },
    isManual: isManual
  };
  return data;
};

export const getLatestValidDispatcherIdAndScenarios =
 (dispatcherType, dispatchers, dispatchersResultsByDispatcherIds,
   installerLatestDispatcherIds) =>
 {
   let latestDispatcherScenariosSummary = {};
   let latestDispatcherId = 0;
   let latestDispatcherNumber = 0;
   let dispatcherNumbersGroup = [];
   let result = {};
   if (dispatcherType !== dispatcherTypeHelper.INSTALLERTESTS)
   {
     const dispatcherIds = dispatchers.map(d => d.id).sort();
     while (keys(latestDispatcherScenariosSummary).length === 0 &&
      dispatcherIds.length !== 0)
     {
       latestDispatcherId = dispatcherIds.pop();
       latestDispatcherScenariosSummary =
        dispatchersResultsByDispatcherIds[latestDispatcherId];
     }

     dispatcherNumbersGroup = uniq(dispatchers.filter(
       d => d.id === latestDispatcherId).map(d => d.number).
       sort((a, b) => b - a));
     latestDispatcherNumber = dispatcherNumbersGroup[0];
   }
   else
   {
     latestDispatcherId =
      installerLatestDispatcherIds[installerLatestDispatcherIds.length - 1];
     installerLatestDispatcherIds.forEach(id => {
       const scenariosSummary = dispatchersResultsByDispatcherIds[id];
       keys(scenariosSummary).forEach(
         scenarioStatus =>
         {
           latestDispatcherScenariosSummary[scenarioStatus] ?
             latestDispatcherScenariosSummary[scenarioStatus] =
             latestDispatcherScenariosSummary[scenarioStatus] +
              scenariosSummary[scenarioStatus] :
             latestDispatcherScenariosSummary[scenarioStatus] =
              scenariosSummary[scenarioStatus];
         }
       );
     });

     dispatcherNumbersGroup = uniq(dispatchers.filter(
       d => installerLatestDispatcherIds.includes(d.id)).
       map(d => d.number).sort((a, b) => b - a));
     latestDispatcherNumber = dispatcherNumbersGroup[0];
   }
   result =
   {
     id: latestDispatcherId,
     number: latestDispatcherNumber,
     scenariosSummary: latestDispatcherScenariosSummary,
     numbersGroup: dispatcherNumbersGroup
   };
   return result;
 };



// WEBPACK FOOTER //
// src/helpers/buildHealth.js